import {Column, Entity, PrimaryColumn} from "typeorm";

@Entity("bioma")
export class Bioma  {
    @PrimaryColumn()
    id?:string
    @Column()
    nome?: string
    @Column()
    excluido?: boolean
}
